//retrieve the token
export const GET_LOGIN_BEGIN = 'GET_LOGIN_BEGIN';
export const GET_LOGIN_SUCCESS = 'GET_LOGIN_SUCCESS';
export const GET_LOGIN_FAILED = 'GET_LOGIN_FAILED';
export const ON_LOGIN_NEEDED = 'ON_LOGIN_NEEDED';
export const IS_LOADING_ON_LOGIN = 'IS_LOADING_ON_LOGIN';
export const LOGIN_COMPLETED = 'LOGIN_COMPLETED';
export const TOGGLE_RESET_NOTICE = 'TOGGLE_RESET_NOTICE';
